import { blobResponse } from "Components/constants/Common";
import { COUNT_PER_AMOUNT, COUNT_PER_GST, HSN_DROPDOWN, PRODUCT_DROP, PRODUCT_RATE, QUOTATION, QUOTATION_LIST, QUOTATION_PDF, QUOTATION_STATUS_EDIT, TOTAL_AMOUNT, VENDOR_DROP, VIEW_QUOTATION } from "./ApiRoutes";
import { authData } from "./services";

export const listOfQuotationApi = async (data: object) => {
  const response = await authData.post(QUOTATION_LIST, data);
  return response?.data;
};
export const quotationApi = async (data: object) => {
  const response = await authData.post(QUOTATION, data);
  return response?.data;
};
export const editQuotationStatusApi = async (id: number, data: object) => {
  const response = await authData.put(`${QUOTATION_STATUS_EDIT}${id}`, data);
  return response?.data;
};
export const viewQuotationApi = async (id: number) => {
  const response = await authData.get(`${VIEW_QUOTATION}${id}`);
  return response?.data;
};
export const vendorListApi = async (data: object) => {
  const response = await authData.post(VENDOR_DROP, data);
  return response?.data;
};
export const productListApi = async (data: object) => {
  const response = await authData.post(PRODUCT_DROP, data);
  return response?.data;
};
export const amountCountApi = async (data: object) => {
  const response = await authData.post(COUNT_PER_AMOUNT, data);
  return response?.data;
};
export const gstCountApi = async (data: object) => {
  const response = await authData.post(COUNT_PER_GST, data);
  return response?.data;
};
export const totalAmountApi = async (data: object) => {
  const response = await authData.post(TOTAL_AMOUNT, data);
  return response?.data;
};
export const hsnDropdownApi = async () => {
  const response = await authData.get(HSN_DROPDOWN);
  return response?.data;
};
export const productRateApi = async (data:object) => {
  const response = await authData.post(PRODUCT_RATE, data);
  return response?.data;
};
export const quotationPdfApi = async (id: number) => {
  const response = await authData.get(`${QUOTATION_PDF}${id}`, blobResponse);
  return response;
};